module.exports = __webpack_public_path__ + "components/carousel-nearby-mountains/static/icon-caret-right-fec82637a4ad44e2ae6b625d8c16cdc9.svg";